var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2212_33181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.7834C25 11.897 24.9205 11.0447 24.7727 10.2266H13V15.0618H19.7273C19.4375 16.6243 18.5568 17.9482 17.233 18.8345V21.9709H21.2727C23.6364 19.7947 25 16.5902 25 12.7834Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9996 25C16.3746 25 19.2041 23.8807 21.2723 21.9716L17.2325 18.8352C16.1132 19.5852 14.6814 20.0284 12.9996 20.0284C9.74387 20.0284 6.98819 17.8295 6.00524 14.875H1.8291V18.1136C3.88592 22.1989 8.11319 25 12.9996 25Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00568 14.8754C5.75568 14.1254 5.61364 13.3242 5.61364 12.5004C5.61364 11.6765 5.75568 10.8754 6.00568 10.1254V6.88672H1.82955C0.982954 8.57422 0.5 10.4833 0.5 12.5004C0.5 14.5174 0.982954 16.4265 1.82955 18.114L6.00568 14.8754Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9996 4.97159C14.8348 4.97159 16.4825 5.60227 17.778 6.84091L21.3632 3.25568C19.1984 1.23864 16.3689 0 12.9996 0C8.11319 0 3.88592 2.80114 1.8291 6.88636L6.00524 10.125C6.98819 7.17045 9.74387 4.97159 12.9996 4.97159Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2212_33181"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 25,
    height: 25,
    rx: 6.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.143cf5f531b5b84d9432c8e06cc3b2a9.svg";
export { ForwardRef as ReactComponent };